<template>
  <company005 />
</template>

<script>
import company005 from '@/pages/company/p_company005.vue';

export default {
  components: {
    company005
  }
};
</script>
